import { getDateIntervalColumnFieldKey } from '@components/TimeLineGrid/helpers'
import { DateInterval } from '@components/TimeLineGrid/helpers/splitIntervalByPeriod'

import { ObjectDataRecord, TimeLineGridDataRecord, TimeLineGroupedData } from '@types'

// Функция для формирования готовых для таблицы данных в зависимости от сгенерированных временных интервалов на основе сгруппированных данных
export const groupByTimeIntervals = (
  groupedData: TimeLineGroupedData[],
  intervals: DateInterval[],
  dateField: string,
  objectYKeyField: string,
  groupId = ''
): TimeLineGridDataRecord[] => {
  return groupedData.map(item => {
    // Создаем новый объект для результата
    const result: TimeLineGridDataRecord = {
      id: item.yElement[objectYKeyField] + (groupId ? `_${groupId}` : ''),
      yElement: item.yElement,
      groupId,
      columnsInfo: {},
    } as TimeLineGridDataRecord

    // Сортируем исходный xArray по возрастанию даты
    const sortedXArray = [...item.xArray].sort((a, b) => {
      const dateA = new Date(a[dateField]).getTime()
      const dateB = new Date(b[dateField]).getTime()

      return dateA - dateB
    })

    // Обрабатываем каждый интервал
    intervals.forEach(interval => {
      // Формируем ключ интервала
      const key = getDateIntervalColumnFieldKey(interval.startDate, interval.endDate)

      // Фильтруем элементы, попадающие в интервал
      const filteredItems = sortedXArray.filter(xItem => {
        const itemDate = new Date(xItem[dateField])
        const startDate = new Date(interval.startDate)
        const endDate = new Date(interval.endDate)

        return itemDate >= startDate && itemDate <= endDate
      })

      const columnInfo = {
        startDate: interval.startDate,
        endDate: interval.endDate,
      }

      // Приводим тип к ObjectDataRecord[]
      result[key as `[${string};${string}]`] = filteredItems.map(item => {
        return {
          ...item,
          columnInfo,
        }
      }) as ObjectDataRecord[]

      result.columnsInfo[key] = columnInfo
    })

    return result
  })
}
